import "./polyfills/promise-with-resolvers";
import { createRoot } from "react-dom/client";
import { AppRoot } from "./AppRoot.tsx";
import "./index.css";
import "./lib/i18n";
import "./lib/sentry";
import { markChunkLoadRecoveryBootstrapSucceeded } from "./lib/chunk-load-error";

createRoot(document.getElementById("root")!).render(
  <AppRoot />,
);

const markSuccessfulBootstrap = () => {
  window.requestAnimationFrame(() => {
    markChunkLoadRecoveryBootstrapSucceeded();
  });
};

if (document.readyState === "complete") {
  markSuccessfulBootstrap();
} else {
  window.addEventListener("load", markSuccessfulBootstrap, { once: true });
}
